import { useState } from 'react';
import { FormModal, Radio } from './ui';

const MODAL_TITLE = 'Select the insurance that applies:';
const MODAL_MOBILE_TITLE = 'Select the insurance that applies:';

const InputPersonalInsurancePickerModal = ({ insuranceTypes, useSelection, onCancel, onAccept }) => {
    const [selection, setSelection] = useSelection();
    const [startingSelection] = useState(selection);

    const handleCancel = () => {
        // Reset selection to starting selection if user cancels
        setSelection(startingSelection);
        onCancel();
    };
    const handleAccept = () => {
        onAccept();
    };

    const handleRadioChange = (e, option) => {
        let thisSelection = [];
        thisSelection = thisSelection.filter(selected => selected.id !== option.id);
        if (e.target.checked) {
            thisSelection.push(option);
        }
        setSelection(thisSelection);
    };

    return (
        <FormModal
            title={MODAL_TITLE}
            titleMobile={MODAL_MOBILE_TITLE}
            onCancel={handleCancel}
            onConfirm={handleAccept}
            maxWidth={'810px'}
            className="personal"
            itemSelector="radio-container"
            maxColumns={2}
            compressToContent={true}
        >
            {insuranceTypes.map(option => (
                <div key={option.id} className="radio-container">
                    <Radio
                        id={`insurance-type-${option.id}`}
                        value={selection.find(selected => selected.id === option.id)}
                        checkHandler={e => handleRadioChange(e, option)}
                        name={'insurance-type'}
                    />
                    <label className="check-box-label" htmlFor={`insurance-type-${option.id}`}>
                        {option.name}
                    </label>
                </div>
            ))}
        </FormModal>
    );
};

export default InputPersonalInsurancePickerModal;
